import EmployeeWorkInTimestampComponents from "../components/EmployeeWorkInTimestamp";
import useEmployeeWorkInTimestamp from "../hooks/useEmployeeWorkInTimestamp";

function EmployeeWorkInTimestamp() {
  const employeeWorkInTimestampProps = useEmployeeWorkInTimestamp();
  return (
    <EmployeeWorkInTimestampComponents {...employeeWorkInTimestampProps} />
  );
}

export default EmployeeWorkInTimestamp;
